import { ensureGlobalGa4 } from "./utils/global-ga4";

let initialized = false;
let gaTrackingId = null;
const sentGlobalPageViews = new Set();

export function isInitialized() {
  return initialized;
}

export function initialize(newGaTrackingId, path, title) {
  function gtag() {
    window.dataLayer.push(arguments);
  }

  if (!initialized) {
    gaTrackingId = newGaTrackingId;

    const cookieConsent = document.cookie.split("; ").find(row => row.startsWith("cookie_consent_level"));

    if (!cookieConsent) {
      console.warn("Cookie consent not found or not accepted.");
      return;
    }

    const consentValue = JSON.parse(decodeURIComponent(cookieConsent.split("=")[1]));

    if (!consentValue.tracking) {
      console.warn("Tracking is not enabled in cookie consent.");
      return;
    }

    const gtmScript = document.createElement("script");
    gtmScript.type = "text/javascript";
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=" + gaTrackingId;

    document.head.appendChild(gtmScript);

    window.dataLayer = window.dataLayer || [];
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaTrackingId);

    initialized = true;
  }

  // Always send page_view event when initialize is called
  if (window.gtag && gaTrackingId) {
    window.gtag("event", "page_view", {
      send_to: gaTrackingId,
      page_title: title,
      page_path: path
    });
  } else if (initialized) {
    // This case should ideally not happen if initialized is true, but as a fallback
    console.warn("gtag function or tracking ID not available to send page_view.");
  }
}

function buildPageLocation(pagePath) {
  if (typeof window === "undefined" || !window.location?.origin) {
    return pagePath;
  }

  try {
    return new URL(pagePath, window.location.origin).toString();
  } catch {
    return pagePath;
  }
}

export function sendGlobalJourneyPageView(globalMeasurementId, pageView, navigationKey) {
  if (typeof window === "undefined" || !pageView?.pagePath || !ensureGlobalGa4(window, globalMeasurementId)) {
    return;
  }

  const dedupeKey = `${globalMeasurementId}:${navigationKey || pageView.pagePath}`;
  if (sentGlobalPageViews.has(dedupeKey)) {
    return;
  }

  try {
    window.gtag("event", "page_view", {
      send_to: globalMeasurementId,
      page_title: pageView.pageTitle,
      page_path: pageView.pagePath,
      page_location: buildPageLocation(pageView.pagePath),
      page_type: pageView.pageType,
      app_area: pageView.appArea
    });
    sentGlobalPageViews.add(dedupeKey);
  } catch (error) {
    // Analytics must not interrupt navigation.
  }
}

export function resetGlobalJourneyDedupeForTests() {
  sentGlobalPageViews.clear();
}
